/* CYBEART COLLECTION TOOLS v2 (2026-09-29) — see sections/cy-collection-tools.liquid.
   Filters the cards Kalles' main-collection renders (matched by their product link), live counts, chips, the drawer,
   the grid switch (cart attribute products_items_per_row, which Kalles reads server-side), centred rows, a sort menu,
   and the state in the URL hash (#filter=size:XXL;stock:in).
   Two kinds of card:
   - split cards (mice, keyboards: one card per colour, link ?variant=): judged on THAT variant;
   - cards with variant pills (pads: Desk-Mat / L / Aurora): judged on any variant, and when a size / series is
     chosen the card is switched to that variant by clicking its own pill (cy-product-card.js does the rest), so
     picture, price and link follow the filter. Clearing puts the card back on the variant it started on. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cyct]');
  if (!root) return;
  var grid = document.querySelector('.hdt-collection-products');
  function json(sel, fb) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return fb; } }
  var data = json('[data-cyct-data]', []), swatches = json('[data-cyct-swatches]', {}), logos = json('[data-cyct-logos]', {});
  var labels = json('[data-cyct-labels]', {});
  /* COLLECTIONS IN PLACE (2026-10-05): the collection cards are a single-choice filter on the type's root page (key
     "collection", values = card collection handles, membership p.c); elsewhere they stay links to root#filter=… */
  /* RANGES (owner 2026-10-05, second pass): the header menu's collection items for this type + "All" (index = data-rng
     on the title-bar rows and the drawer cards). Each range is a filter: r.flt = "collection:<handle>" or a drawer
     filter such as "size:XXL" (the collection metafield cybeart.filter_link); "All" = none of the range keys set. */
  var RANGES = json('[data-cyct-ranges]', []), ON_ROOT = root.hasAttribute('data-on-root');
  function parseFlt(flt) {
    return String(flt || '').split(';').filter(Boolean).map(function (part) {
      var kv = part.split(':');
      return { k: kv[0], vals: (kv[1] || '').split('.').map(function (v) { try { return decodeURIComponent(v); } catch (e) { return v; } }).filter(Boolean) };
    }).filter(function (p) { return p.k && p.vals.length; });
  }
  RANGES.forEach(function (r) { r.parts = parseFlt(r.flt); });
  var ROOTR = RANGES.filter(function (r) { return r.all; })[0] || null;
  var COL_VALUES = [], RKEYS = {};
  RANGES.forEach(function (r) { r.parts.forEach(function (p) { RKEYS[p.k] = 1; if (p.k === 'collection') COL_VALUES = COL_VALUES.concat(p.vals); }); });
  /* collections that are not ranges but link here as collection:<handle> (APEX Series, Batman pads …) */
  var XCOLS = json('[data-cyct-xcols]', {});
  Object.keys(XCOLS).forEach(function (h) { COL_VALUES.push(h); });
  RKEYS.collection = 1;
  var byHandle = {};
  data.forEach(function (p) { byHandle[p.h] = p; });
  var FINE = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches;
  var TICK = '<span class="cyct__tick" aria-hidden="true"><svg viewBox="0 0 12 12"><path d="M2.5 6.2l2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  /* labels, notes and the option order come from the section settings (Availability labels, Option notes) */
  var sl = (labels.stock || []).map(function (x) { return String(x).trim(); });
  var STOCK = { in: sl[0] || 'In stock', pre: sl[1] || 'Pre-order', out: sl[2] || 'Sold out' };
  var NOTES = labels.notes || {};
  var NOTE_ORDER = Object.keys(NOTES);
  /* a size outline drawn to scale from the note's mm ("900×400 mm"): the largest fills 28 × 14 */
  var SIZE_BOX = {}, maxW = 0;
  NOTE_ORDER.forEach(function (k) { var m = String(NOTES[k]).match(/(\d+)\s*[×x]\s*(\d+)/); if (m) { SIZE_BOX[k] = [+m[1], +m[2]]; maxW = Math.max(maxW, +m[1]); } });
  Object.keys(SIZE_BOX).forEach(function (k) { var sc = 28 / maxW; SIZE_BOX[k] = [SIZE_BOX[k][0] * sc, Math.min(14, SIZE_BOX[k][1] * sc)]; });
  /* tiles (cards) for these groups, chips (pills) for the rest */
  var TILE = { size: 1, series: 1, connection: 1 };

  var groups = Array.prototype.map.call(root.querySelectorAll('[data-cyct-group]'), function (g) {
    return { key: g.getAttribute('data-cyct-group'), level: g.getAttribute('data-level'), single: g.getAttribute('data-single') === '1',
             logos: g.hasAttribute('data-logos'), el: g };
  });
  var state = { collection: [] };
  groups.forEach(function (g) { state[g.key] = []; });
  function label(g, val) { return g.key === 'stock' ? STOCK[val] : val; }
  function colOk(p, h) { return !h || (p.c || []).indexOf(h) >= 0; }
  /* values come from the DOM, but the chips are built as HTML: escape before inserting */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- the options ---------- */
  groups.forEach(function (g) {
    var seen = [];
    data.forEach(function (p) {
      var vals = g.level === 'p' ? [p.p[g.key]] : p.v.map(function (v) { return g.key === 'stock' ? v.st : v[g.key]; });
      vals.forEach(function (x) { if (x && seen.indexOf(x) < 0) seen.push(x); });
    });
    var ord = g.key === 'stock' ? ['in', 'pre', 'out'] : NOTE_ORDER;
    seen.sort(function (a, b) {
      var ia = ord.indexOf(a), ib = ord.indexOf(b);
      if (ia >= 0 || ib >= 0) return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      return a.localeCompare(b);
    });
    /* availability always shows its three states (a state no product is in shows disabled); other groups need two values */
    if (g.key === 'stock') seen = ['in', 'pre', 'out'];
    if (!seen.length || (g.key !== 'stock' && seen.length < 2)) { g.el.hidden = true; return; }
    var box = g.el.querySelector('[data-cyct-opts]');
    g.values = seen;   /* the only values the URL hash may select */
    var kind = g.logos ? 'is-logos' : TILE[g.key] ? 'is-tiles' : 'is-chips';
    box.classList.add(kind);
    box.setAttribute('role', 'group');
    box.innerHTML = seen.map(function (val) {
      var art = '', text = esc(label(g, val)), note = '';   /* admin + product text: escaped before it becomes HTML */
      if (g.key === 'size' && SIZE_BOX[val]) {
        var w = SIZE_BOX[val][0], h = SIZE_BOX[val][1];
        art = '<svg class="cyct__size" viewBox="0 0 30 16" aria-hidden="true"><rect x="' + (15 - w / 2) + '" y="' + (8 - h / 2) + '" width="' + w + '" height="' + h + '" rx="1.4"/></svg>';
        note = esc(NOTES[val] || '');
      } else if (g.key === 'series' && g.level === 'v') {
        /* pad series: a small pad; an RGB edge when its note says RGB */
        note = esc(NOTES[val] || '');
        art = '<span class="cyct__pad' + (/rgb/i.test(note) ? ' is-rgb' : '') + '" aria-hidden="true"></span>';
      } else if (g.key === 'colour') {
        art = '<span class="cyct__sw" aria-hidden="true" style="background:' + String(swatches[val.toLowerCase()] || '#D9D9DE').replace(/"/g, '') + '"></span>';
      } else if (g.key === 'stock') {
        art = '<span class="cyct__dot cyct__dot--' + val + '" aria-hidden="true"></span>';
      } else if (g.key === 'connection') {
        art = val === 'Wireless'
          ? '<svg class="cyct__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 9.5a11 11 0 0 1 15 0M7.5 12.8a6.6 6.6 0 0 1 9 0M10.6 16a2.2 2.2 0 0 1 2.8 0" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="12" cy="18.6" r="1.1" fill="currentColor"/></svg>'
          : '<svg class="cyct__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v6m-3-3h6M9 9h6v4a3 3 0 0 1-6 0zM12 16v5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      var attrs = ' data-k="' + g.key + '" data-v="' + encodeURIComponent(val) + '" aria-pressed="false"';
      if (g.logos) {
        var src = logos[val.toLowerCase()];
        return '<button type="button" class="cys-card cyct__opt cyct__logo"' + attrs + ' aria-label="' + text + '" title="' + text + '">' +
          (src ? '<img src="' + src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=200" alt="" loading="lazy" data-name="' + text + '">' : '<span class="cyct__logotxt">' + text + '</span>') +
          '<span class="cyct__n" data-n></span>' + TICK + '</button>';
      }
      if (TILE[g.key]) {
        return '<button type="button" class="cys-card cyct__opt cyct__tile"' + attrs + '>' + art +
          '<span class="cyct__tl">' + text + (note ? '<em>' + note + '</em>' : '') + '</span><span class="cyct__n" data-n></span>' + TICK + '</button>';
      }
      return '<button type="button" class="cys-chip cyct__opt cyct__pill"' + attrs + '>' + art + '<span>' + text + '</span><span class="cyct__n" data-n></span></button>';
    }).join('');
  });

  /* a logo listed in the setting but not uploaded yet: the name instead of a broken image */
  root.querySelectorAll('.cyct__logo img').forEach(function (img) {
    function fall() { var s = document.createElement('span'); s.className = 'cyct__logotxt'; s.textContent = img.getAttribute('data-name'); img.replaceWith(s); }
    if (img.complete && !img.naturalWidth) fall(); else img.addEventListener('error', fall);
  });

  /* ---------- the section system's card hover (spotlight + running light) for tiles built here ---------- */
  function arm(scope) {
    return;   /* 2026-10-16 design system v3.2: cybeart.js frames and lights every .cys-card; the copy below is kept in git only */
    if (!FINE) return;
    scope.querySelectorAll('.cys-card').forEach(function (tile) {
      if (tile.querySelector(':scope > .cys-spot')) return;
      var spot = document.createElement('span'); spot.className = 'cys-spot'; spot.setAttribute('aria-hidden', 'true'); tile.prepend(spot);
      var ring = document.createElement('span'); ring.className = 'cys-ring'; ring.setAttribute('aria-hidden', 'true'); tile.appendChild(ring);
      var raf = 0, x = 0, y = 0;
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          tile.style.setProperty('--mx', x + 'px'); tile.style.setProperty('--my', y + 'px');
          tile.style.setProperty('--cys-glow', (Math.atan2(y - r.height / 2, x - r.width / 2) * 180 / Math.PI + 90) + 'deg');
        });
      });
    });
  }
  arm(root);

  /* ---------- the cards on the page ---------- */
  var units = [];
  function buildUnits() {
    units = [];
    if (grid) Array.prototype.forEach.call(grid.children, function (el) {
      var a = el.querySelector && el.querySelector('a[href*="/products/"]'); if (!a) return;
      var href = a.getAttribute('href'), m = href.match(/\/products\/([^/?#]+)/), p = m && byHandle[decodeURIComponent(m[1])];
      if (!p) { units.push({ el: el, p: null }); return; }
      var pills = {}, has = false, orig = null;
      el.querySelectorAll('[data-opt][data-variant]').forEach(function (b) {
        pills[b.getAttribute('data-variant')] = b; has = true;
        if (b.classList.contains('is-on')) orig = b.getAttribute('data-variant');
      });
      var v = null;
      if (!has) {
        var vid = (href.match(/[?&]variant=(\d+)/) || [])[1];
        if (vid) p.v.forEach(function (x) { if (String(x.id) === vid) v = x; });
      }
      units.push({ el: el, p: p, v: v, pills: has ? pills : null, orig: orig });
    });
    if (!units.length) data.forEach(function (p) { units.push({ el: null, p: p, v: null }); });
  }
  function vval(v, key) { return key === 'stock' ? v.st : v[key]; }
  function vgroups(skip) { return groups.filter(function (g) { return g.level === 'v' && g.key !== skip && state[g.key].length; }); }
  function okVariant(v, vg, ev) {
    if (ev && vval(v, ev.g.key) !== ev.val) return false;
    return vg.every(function (g) { return state[g.key].indexOf(vval(v, g.key)) >= 0; });
  }
  /* extra = one more {g, val} the unit must also carry (the per-option counts) */
  function matches(u, skip, extra) {
    var p = u.p;
    if (skip !== 'collection' && !colOk(p, state.collection[0])) return false;
    if (extra && extra.g.key === 'collection') return colOk(p, extra.val) && matches(u, 'collection');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.level !== 'p' || g.key === skip || !state[g.key].length) continue;
      if (state[g.key].indexOf(p.p[g.key]) < 0) return false;
    }
    if (extra && extra.g.level === 'p' && p.p[extra.g.key] !== extra.val) return false;
    var vg = vgroups(skip), ev = extra && extra.g.level === 'v' ? extra : null;
    if (!vg.length && !ev) return true;
    return (u.v ? [u.v] : p.v).some(function (v) { return okVariant(v, vg, ev); });
  }
  /* pill cards follow the chosen size / series */
  function follow(u) {
    if (!u.pills) return;
    var vg = vgroups(), want = null;
    if (vg.length) {
      var on = u.el.querySelector('[data-opt].is-on'), cur = on && on.getAttribute('data-variant');
      u.p.v.forEach(function (v) { if (okVariant(v, vg) && (!want || String(v.id) === cur)) want = String(v.id); });
    } else want = u.orig;
    var pill = want && u.pills[want];
    if (pill && !pill.classList.contains('is-on')) pill.click();
  }

  function apply() {
    /* the count is PRODUCTS (unique), not cards: mice and keyboards show one card per colour, and the title bar
       counts products — the two must agree */
    var shown = 0, active = 0, seenP = {}, loose = 0;
    units.forEach(function (u) {
      var ok = !u.p || matches(u);
      if (u.el) u.el.classList.toggle('cyct-hide', !ok);
      if (!ok) return;
      if (u.p) { follow(u); if (!seenP[u.p.h]) { seenP[u.p.h] = 1; shown++; } }
      else loose++;
    });
    shown += loose;
    groups.forEach(function (g) {
      active += state[g.key].length;
      g.el.querySelector('[data-cyct-gclear]').hidden = !state[g.key].length;
      g.el.querySelectorAll('.cyct__opt').forEach(function (b) {
        var val = decodeURIComponent(b.getAttribute('data-v')), on = state[g.key].indexOf(val) >= 0;
        var nk = {};
        units.forEach(function (u) { if (u.p && matches(u, g.key, { g: g, val: val })) nk[u.p.h] = 1; });
        var n = Object.keys(nk).length;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (b.classList.contains('cys-chip')) b.classList.toggle('is-active', on);
        b.classList.toggle('is-none', !on && n === 0); b.disabled = !on && n === 0;
        b.querySelector('[data-n]').textContent = n;
      });
    });
    /* the ranges (title-bar rows + drawer cards): which one is on, live counts with the other filters */
    active += state.collection.length;
    if (ON_ROOT) {
      var onR = activeRange();
      root.querySelectorAll('[data-rng]').forEach(function (a) {
        var r = RANGES[+a.getAttribute('data-rng')]; if (!r) return;
        var on = r === onR, n = rangeCount(r);
        a.classList.toggle('is-on', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        a.classList.toggle('is-none', !on && n === 0);
        var cnt = a.querySelector('[data-n]'); if (cnt) cnt.textContent = n;
      });
    }
    var word = shown === 1 ? ' product' : ' products';
    root.querySelector('[data-cyct-count]').textContent = shown + word;
    var badge = root.querySelector('[data-cyct-badge]'); badge.hidden = !active; badge.textContent = active;
    root.querySelector('[data-cyct-show]').textContent = 'Show ' + shown + word;
    root.querySelector('[data-cyct-dcount]').textContent = active ? '(' + active + ')' : '';
    root.querySelector('[data-cyct-empty]').hidden = shown > 0;
    root.querySelectorAll('.cyct__dclear').forEach(function (b) { b.disabled = !active; });
    var chips = [];
    state.collection.forEach(function (h) {
      var rr = RANGES.filter(function (r) { return r.parts.some(function (p) { return p.k === 'collection' && p.vals.indexOf(h) >= 0; }); })[0];
      var t = rr ? rr.title : (XCOLS[h] || {}).title || h;
      chips.push('<button type="button" class="cys-chip cyct__chip" data-k="collection" data-v="' + encodeURIComponent(h) + '" aria-label="Remove ' + esc(t) + '">' + esc(t) +
        '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3L3 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>');
    });
    groups.forEach(function (g) {
      state[g.key].forEach(function (val) {
        var t = label(g, val);
        chips.push('<button type="button" class="cys-chip cyct__chip" data-k="' + g.key + '" data-v="' + encodeURIComponent(val) + '" aria-label="Remove ' + esc(t) + '">' + esc(t) +
          '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3L3 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>');
      });
    });
    if (chips.length > 1) chips.push('<button type="button" class="cyct__chipclear" data-cyct-clear>Clear all</button>');
    root.querySelector('[data-cyct-chips]').innerHTML = chips.join('');
    writeHash();
    head(shown);
    replay();
    /* for the title bar (and anything else): what the grid shows now */
    var cur = state.collection[0] || '', snap = {};
    Object.keys(state).forEach(function (k) { snap[k] = state[k].slice(); });
    document.dispatchEvent(new CustomEvent('cyct:change', { detail: {
      collection: cur, range: activeRange(), root: ROOTR, onRoot: ON_ROOT,
      shown: shown, active: active, state: snap } }));
  }
  /* ---------- the title bar: subject, lede, breadcrumb, count ---------- */
  var HEAD = root.querySelector('[data-cyct-head]'), CALM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hT = HEAD && HEAD.querySelector('[data-cyct-title]'), hL = HEAD && HEAD.querySelector('[data-cyct-lede]'), hN = HEAD && HEAD.querySelector('[data-cyct-tcount]');
  var hC = HEAD && HEAD.querySelector('[data-cyct-crumb]'), hR = HEAD && HEAD.querySelector('[data-cyct-crumb-root]'), hLive = HEAD && HEAD.querySelector('[data-cyct-live]');
  var base = HEAD ? { title: hT.textContent, lede: hL ? hL.textContent : '', doc: document.title } : null, rollFrom = hN ? +hN.textContent || 0 : 0, rollRaf = 0;
  /* ---------- ranges: which one is on, how many products each would show, choosing one ---------- */
  function sameSet(a, b) { return a.length === b.length && a.every(function (x) { return b.indexOf(x) >= 0; }); }
  function activeRange() {
    var hit = null;
    RANGES.forEach(function (r) {
      if (r.all || hit) return;
      var ok = r.parts.every(function (p) { return sameSet(state[p.k] || [], p.vals); }) &&
        Object.keys(RKEYS).every(function (k) { return r.parts.some(function (p) { return p.k === k; }) || !(state[k] || []).length; });
      if (ok) hit = r;
    });
    if (hit) return hit;
    return Object.keys(RKEYS).every(function (k) { return !(state[k] || []).length; }) ? ROOTR : null;
  }
  /* a range's count = the products it would show with the filters outside the range keys */
  function rangeCount(r) {
    var keep = {}; Object.keys(RKEYS).forEach(function (k) { keep[k] = state[k]; state[k] = []; });
    r.parts.forEach(function (p) { state[p.k] = p.vals.slice(); });
    var nk = {}; units.forEach(function (u) { if (u.p && matches(u)) nk[u.p.h] = 1; });
    Object.keys(keep).forEach(function (k) { state[k] = keep[k]; });
    return Object.keys(nk).length;
  }
  /* only values the page knows (the hash and the menu are input): collections from the ranges, others from the groups */
  function validVals(k, vals) {
    if (k === 'collection') return vals.filter(function (v) { return COL_VALUES.indexOf(v) >= 0; }).slice(0, 1);
    var g = groups.filter(function (x) { return x.key === k; })[0];
    return g && g.values ? vals.filter(function (v) { return g.values.indexOf(v) >= 0; }) : [];
  }
  function pickRange(r) {
    var wasOn = activeRange() === r;
    Object.keys(RKEYS).forEach(function (k) { if (state[k]) state[k] = []; });
    if (!wasOn && !r.all) r.parts.forEach(function (p) { if (state[p.k]) state[p.k] = validVals(p.k, p.vals); });
    apply();
  }
  function swapText(el, txt) {
    if (!el || el.textContent === txt) return;
    el.textContent = txt;
    if (CALM) return;
    el.classList.remove('is-swap'); void el.offsetWidth; el.classList.add('is-swap');
  }
  function roll(to) {
    if (!hN) return;
    cancelAnimationFrame(rollRaf);
    var from = rollFrom; rollFrom = to;
    if (CALM || from === to) { hN.textContent = to; return; }
    var t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / 420), e = 1 - Math.pow(1 - k, 3);
      hN.textContent = Math.round(from + (to - from) * e);
      if (k < 1) rollRaf = requestAnimationFrame(step);
    })(t0);
  }
  /* the subject: the chosen collection; else ONE chosen value of a product group (brand, theme, series, style,
     connection) in front of the type ("Harry Potter Mouse Pads"); else what the page was loaded with */
  function head(shown) {
    if (!HEAD) return;
    var title = base.title, lede = base.lede, r = activeRange();
    if (ON_ROOT && ROOTR) {
      if (r && !r.all) {
        /* a range is on — but a further product filter (brand, series …) names it: "Harry Potter Desk Mats" */
        var extra = [];
        groups.forEach(function (g) { if (!RKEYS[g.key] && g.key !== 'stock' && g.key !== 'colour' && state[g.key].length) extra.push(state[g.key].length === 1 ? state[g.key][0] : null); });
        title = extra.length === 1 && extra[0] ? extra[0] + ' ' + r.title : r.title;
        lede = r.desc || ROOTR.desc;
      } else if (state.collection[0] && XCOLS[state.collection[0]]) {
        var xc = XCOLS[state.collection[0]];
        title = xc.title; lede = xc.desc || ROOTR.desc;
      } else {
        var one = [];
        groups.forEach(function (g) { if (g.key !== 'stock' && g.key !== 'colour' && state[g.key].length) one.push(state[g.key].length === 1 ? state[g.key][0] : null); });
        title = one.length === 1 && one[0] ? one[0] + ' ' + ROOTR.title : ROOTR.title;
        lede = ROOTR.desc || base.lede;
      }
    }
    swapText(hT, title);
    if (hL) swapText(hL, lede);
    if (hC) hC.textContent = title;
    if (hR) hR.hidden = ON_ROOT && ROOTR ? title === ROOTR.title : hR.hidden;
    roll(shown);
    if (hLive) hLive.textContent = shown + (shown === 1 ? ' product: ' : ' products: ') + title;
    if (base.doc.indexOf(base.title) >= 0) document.title = base.doc.replace(base.title, title);
    showTile();
  }
  /* the cards load again when the filter changes (owner 2026-10-05: "animate and load cards again when filtering a new
     collection or anything from the drawer"): the cards that remain fade + rise in, one after another (40ms apart, the
     first 12; the rest together). Not on the first paint (Kalles' own reveal runs then); nothing for reduced motion.
     Only the grid items move — the card inside is untouched. */
  var lastSig = null;
  function replay() {
    var sig = JSON.stringify(state);
    if (lastSig === null || sig === lastSig) { lastSig = sig; return; }
    lastSig = sig;
    if (CALM || !grid) return;
    var k = 0;
    units.forEach(function (u) {
      if (!u.el || u.el.classList.contains('cyct-hide')) return;
      u.el.classList.remove('cyct-in'); void u.el.offsetWidth;
      u.el.style.setProperty('--cyct-i', Math.min(k++, 12));
      u.el.classList.add('cyct-in');
    });
  }
  if (grid) grid.addEventListener('animationend', function (e) { if (e.animationName === 'cyctIn') e.target.classList.remove('cyct-in'); });
  /* the selected tile is always in view in the rail (phones scroll it) */
  function showTile() {
    var r = HEAD && HEAD.querySelector('.cyct__ranges'), t = r && r.querySelector('.cyct__rg.is-on');
    if (!t) return;
    var l = t.offsetLeft - r.offsetLeft, end = l + t.offsetWidth;
    if (l < r.scrollLeft || end > r.scrollLeft + r.clientWidth) r.scrollTo({ left: Math.max(0, l - 16), behavior: CALM ? 'auto' : 'smooth' });
  }
  /* rail: a fade on the edge that has more tiles */
  var rail = HEAD && HEAD.querySelector('.cyct__ranges'), rwrap = rail && rail.parentNode;
  function railEdges() {
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    rwrap.classList.toggle('is-more-start', rail.scrollLeft > 4);
    rwrap.classList.toggle('is-more-end', max - rail.scrollLeft > 4);
  }
  if (rail) {
    rail.addEventListener('scroll', railEdges, { passive: true }); addEventListener('resize', railEdges); railEdges();
  }

  function toggle(k, val) {
    var g = groups.filter(function (x) { return x.key === k; })[0], a = state[k], i = a.indexOf(val);
    if (i >= 0) a.splice(i, 1);
    else if (k === 'collection' || (g && g.single)) state[k] = [val];
    else a.push(val);
    apply();
  }
  function clearAll() { state.collection = []; groups.forEach(function (g) { state[g.key] = []; }); apply(); }
  /* the public handle: the title bar drives the same state (window.cyct.set('collection', ['desk-mats'])) */
  window.cyct = {
    get: function () { var s = {}; Object.keys(state).forEach(function (k) { s[k] = state[k].slice(); }); return s; },
    set: function (k, vals) { if (!state[k] || (k === 'collection' && !ON_ROOT)) return; state[k] = (vals || []).slice(0, k === 'collection' ? 1 : 99); apply(); },
    clear: clearAll, ranges: RANGES, onRoot: ON_ROOT
  };

  /* ---------- hash ---------- */
  function writeHash() {
    var parts = [];
    if (state.collection.length) parts.push('collection:' + encodeURIComponent(state.collection[0]));
    groups.forEach(function (g) { if (state[g.key].length) parts.push(g.key + ':' + state[g.key].map(encodeURIComponent).join('.')); });
    var h = parts.length ? '#filter=' + parts.join(';') : '';
    if (location.hash !== h) history.replaceState(null, '', location.pathname + location.search + h);
  }
  function readHash() {
    /* a menu link to this same page changes only the hash: start from nothing, then take the hash */
    Object.keys(state).forEach(function (k) { state[k] = []; });
    var m = location.hash.match(/filter=([^&]+)/); if (!m) return;
    /* a link that IS a range (Mouse Pads M & L = size:L.M) takes the whole range, even where the drawer group is single */
    var whole = RANGES.filter(function (r) { return !r.all && r.flt && decodeURIComponent(r.flt) === decodeURIComponent(m[1]); })[0];
    if (whole) { whole.parts.forEach(function (p) { if (state[p.k]) state[p.k] = validVals(p.k, p.vals); }); return; }
    m[1].split(';').forEach(function (part) {
      var kv = part.split(':'); if (!state[kv[0]] || !kv[1]) return;
      if (kv[0] === 'collection') {
        var h = ''; try { h = decodeURIComponent(kv[1]); } catch (e) {}
        if (ON_ROOT && COL_VALUES.indexOf(h) >= 0) state.collection = [h];
        return;
      }
      var g = groups.filter(function (x) { return x.key === kv[0]; })[0]; if (!g || !g.values) return;
      /* only values that exist as options: the hash is untrusted input */
      var vals = kv[1].split('.').map(function (v) { try { return decodeURIComponent(v); } catch (e) { return ''; } }).filter(function (v) { return g.values.indexOf(v) >= 0; });
      state[kv[0]] = g.single ? vals.slice(0, 1) : vals;
    });
  }

  /* ---------- drawer ---------- */
  var dlg = root.querySelector('[data-cyct-drawer]'), opener = null;
  function open() {
    if (!dlg || dlg.open) return;
    opener = document.activeElement; closeMenu();
    dlg.showModal(); document.documentElement.classList.add('cyct-lock');
    requestAnimationFrame(function () { dlg.classList.add('is-in'); });
  }
  function close() {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-in');
    var done = function () { dlg.close(); document.documentElement.classList.remove('cyct-lock'); if (opener) opener.focus(); };
    /* 320 = --cy-dur-sheet, the drawer's slide (cy-collection-tools.css) */
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 320);
  }
  if (dlg) {
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  /* ---------- sort menu ---------- */
  var sbox = root.querySelector('[data-cyct-sortbox]'), sbtn = sbox && sbox.querySelector('[data-cyct-sortbtn]'), menu = sbox && sbox.querySelector('[data-cyct-menu]');
  function openMenu() {
    if (!menu) return; menu.hidden = false; sbtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { menu.classList.add('is-in'); });
    var on = menu.querySelector('.is-on') || menu.querySelector('[role="option"]'); if (on) on.focus({ preventScroll: true });
  }
  function closeMenu(focus) {
    if (!menu || menu.hidden) return; menu.classList.remove('is-in'); menu.hidden = true; sbtn.setAttribute('aria-expanded', 'false');
    if (focus) sbtn.focus();
  }
  function pick(li) {
    var u = new URL(location.href); u.searchParams.set('sort_by', li.getAttribute('data-value')); u.searchParams.delete('page');
    location.href = u.toString();
  }
  if (menu) {
    menu.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]')), i = items.indexOf(document.activeElement);
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(items.length - 1, i + 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(0, i - 1)].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) pick(items[i]); }
      else if (e.key === 'Escape' || e.key === 'Tab') closeMenu(e.key === 'Escape');
    });
    document.addEventListener('click', function (e) { if (!sbox.contains(e.target)) closeMenu(); });
  }

  root.addEventListener('click', function (e) {
    var li = e.target.closest('[role="option"]'); if (li && menu && menu.contains(li)) return pick(li);
    var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
    /* collection cards filter in place on the root page (a modified click still opens the link) */
    if (ON_ROOT && t.hasAttribute('data-rng') && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button)) {
      var rg = RANGES[+t.getAttribute('data-rng')]; if (!rg) return;
      e.preventDefault();
      return pickRange(rg);
    }
    if (t.hasAttribute('data-cyct-sortbtn')) return menu.hidden ? openMenu() : closeMenu();
    if (t.hasAttribute('data-cyct-open')) return open();
    if (t.hasAttribute('data-cyct-close')) return close();
    if (t.hasAttribute('data-cyct-clear')) return clearAll();
    if (t.hasAttribute('data-cyct-gclear')) { state[t.getAttribute('data-cyct-gclear')] = []; return apply(); }
    if (t.classList.contains('cyct__opt') || t.classList.contains('cyct__chip')) return toggle(t.getAttribute('data-k'), decodeURIComponent(t.getAttribute('data-v')));
    if (t.hasAttribute('data-cyct-cols')) return setCols(+t.getAttribute('data-cyct-cols'), true);
  });

  /* ---------- grid: 4/5/6 desktop, 2/3/4 tablet, 1/2 phone; short rows are centred ----------
     4K (2400px+, owner 2026-10-05: "full screen collections on a 4K screen and 6 cards in a row"): its own setting, 6 by
     default; a choice made there is kept in this browser only (localStorage), so other screens keep theirs. */
  var ALLOWED = { m: [1, 2], t: [2, 3, 4], d: [4, 5, 6], k: [4, 5, 6] };
  var K4 = 6; try { var k4s = +localStorage.getItem('cyct-cols-4k'); if (ALLOWED.k.indexOf(k4s) >= 0) K4 = k4s; } catch (e) {}
  var defs = (root.getAttribute('data-defaults') || '2.3.5').split('.').map(Number);
  function bp() { return matchMedia('(min-width: 2400px)').matches ? 'k' : matchMedia('(min-width: 1150px)').matches ? 'd' : matchMedia('(min-width: 768px)').matches ? 't' : 'm'; }
  var cols = defs.slice();
  if (grid) {
    var c = grid.className;
    cols = [+(c.match(/(?:^|\s)hdt-grid-cols-(\d)/) || [])[1] || defs[0], +(c.match(/md:hdt-grid-cols-(\d)/) || [])[1] || defs[1], +(c.match(/lg:hdt-grid-cols-(\d)/) || [])[1] || defs[2]];
  }
  ['m', 't', 'd'].forEach(function (k, i) { if (ALLOWED[k].indexOf(cols[i]) < 0) cols[i] = defs[i]; });
  function layout() {
    if (!grid) return;
    var dk = bp() === 'k' ? K4 : cols[2];
    grid.className = grid.className
      .replace(/(^|\s)hdt-grid-cols-\d/, '$1hdt-grid-cols-' + cols[0])
      .replace(/md:hdt-grid-cols-\d/, 'md:hdt-grid-cols-' + cols[1])
      .replace(/lg:hdt-grid-cols-\d/, 'lg:hdt-grid-cols-' + dk);
    grid.style.setProperty('--cyct-m', cols[0]); grid.style.setProperty('--cyct-t', cols[1]); grid.style.setProperty('--cyct-d', dk);
    grid.classList.add('cyct-flex');
  }
  function paint() {
    layout();
    var b = bp(), idx = b === 'm' ? 0 : b === 't' ? 1 : 2, cur = b === 'k' ? K4 : cols[idx];
    root.querySelectorAll('[data-cyct-cols]').forEach(function (btn) {
      var n = +btn.getAttribute('data-cyct-cols'), on = n === cur;
      btn.hidden = ALLOWED[b].indexOf(n) < 0;
      btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function setCols(n, save) {
    var b = bp();
    if (b === 'k') { K4 = n; paint(); if (save) { try { localStorage.setItem('cyct-cols-4k', String(n)); } catch (e) {} } return; }
    cols[b === 'm' ? 0 : b === 't' ? 1 : 2] = n; paint();
    if (save) fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ attributes: { products_items_per_row: cols.join('.') } })
    }).catch(function () {});
  }
  var lastBp = bp();
  addEventListener('resize', function () { if (bp() !== lastBp) { lastBp = bp(); paint(); } });

  if (grid && 'MutationObserver' in window) {
    var busy = false;
    new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; buildUnits(); apply(); }); })
      .observe(grid, { childList: true });
  }

  document.documentElement.classList.add('cyct-on');
  addEventListener('hashchange', function () { if (/filter=/.test(location.hash) || !location.hash) { readHash(); apply(); } });
  readHash();
  buildUnits();
  paint();
  apply();
})();
